
import { Vue, Component, Prop } from "vue-property-decorator";
import Song from "../lib/song";
import JSZip from "jszip";
import { download } from "../utils/download";
import SongListItem from "./SongListItem.vue";
import BeatButton from "./common/BeatButton.vue";
import BeatModal from "./common/BeatModal.vue";

@Component({
  components: {
    SongListItem,
    BeatButton,
    BeatModal
  },
  props: {
    songs: {
      type: Array,
      required: true
    }
  }
})
export default class SongListVue extends Vue {
  @Prop() readonly songs!: Song[];

  isShowLoading: boolean = false;

  handleSelect(index: number) {
    let song = this.songs[index];
    if (song) return this.$emit("select", song);

    throw new Error("Song of index not Exist.");
  }

  async transformAll() {
    this.isShowLoading = true;
    try {
      let zip = new JSZip();
      this.songs.forEach(song => {
        let wrapFolder = zip.folder(song.name);
        song.files.forEach(file => {
          if (!wrapFolder) {
            throw new Error("Wrap folder not exist.");
          }
          return wrapFolder.file(file.name, file);
        });
      });
      let zipFile = new File(
        [await zip.generateAsync({ type: "blob" })],
        `${this.songs[0].name} and other ${this.songs.length} songs.zip`
      );
      this.isShowLoading = false;
      download(zipFile);
    } finally {
      this.isShowLoading = false;
    }
  }
}
